import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OwnerGroup } from 'src/objects/owner-group';
import { Owner } from '../../objects/owner';
import { ServiceArea } from '../../objects/service-area';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class OwnerService extends BaseService {
  createInstance = (attributes: Owner): Owner => attributes;

  getServiceAreas(): Observable<ServiceArea[]> {
    const url = `${ this.baseUrl }/public/service_areas/`;
    const params = {
      ['owner_group_slug']: this.hostname,
    };

    const mapTo = (attributes: ServiceArea) => attributes as ServiceArea;
    return this.getPagedRequest<ServiceArea, ServiceArea>({ url, params, mapTo });
  }

  
  getOwner(): Observable<Owner> {
    const url = `${ this.baseUrl }/public/owner_groups/${ this.hostname }`;

    return this.http.get<OwnerGroup>(url)
      .pipe(
        map((ownerGroup: OwnerGroup) => ({
          ...ownerGroup.primary_owner,
          tipping_enabled: ownerGroup.tipping_enabled,
          owner_group_image_url: ownerGroup.image_url,
          created_at: null,
        } as Owner))
      );
  }
  

  getOwnerAndServiceAreas(): Observable<{owner: Owner; serviceAreas: ServiceArea[]}> {
    return combineLatest([
      this.getServiceAreas(),
      this.getOwner(),
    ])
      .pipe(
        map(([serviceAreas, owner]) => ({
          owner,
          serviceAreas,
        })),
      );
  }
}
